import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';

interface LoadMoreLessProps {
  shouldShowLoadMore: boolean;
  shouldShowLess: boolean;
  getCurrentlyShowingFields: () => number;
  getTotalAvailableFields: () => number;
  setShowAll: (show: boolean) => void;
}

const LoadMoreLess: React.FC<LoadMoreLessProps> = ({
  shouldShowLoadMore,
  shouldShowLess,
  getCurrentlyShowingFields,
  getTotalAvailableFields,
  setShowAll,
}) => {
  const { t } = useTranslation('feed');

  if (!shouldShowLoadMore && !shouldShowLess) {
    return null;
  }

  return (
    <div className="flex justify-end pt-4">
      {shouldShowLoadMore && (
        <Button
          label={t('Load More... ({{currentlyShowing}} of {{total}} shown)', {
            ns: 'feed',
            currentlyShowing: getCurrentlyShowingFields(),
            total: getTotalAvailableFields(),
          })}
          buttonSize="xs"
          buttonType="secondary"
          className="!text-xxs rounded-full !bg-opacity-30"
          onPress={() => setShowAll(true)}
        />
      )}

      {shouldShowLess && (
        <Button
          label={t('Show Less ({{currentlyShowing}} shown)', {
            ns: 'feed',
            currentlyShowing: getCurrentlyShowingFields(),
          })}
          buttonSize="xs"
          buttonType="secondary"
          className="!text-xxs rounded-full !bg-opacity-20"
          onPress={() => setShowAll(false)}
        />
      )}
    </div>
  );
};

export default LoadMoreLess;
